import React, { Component } from "react";

import Winners from "./Winners";

import { Parallax } from "react-parallax";
import ModelSpecs from "./ModelSpecs";

export default class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleToggleClick = this.handleToggleClick.bind(this);
  }

  handleToggleClick(e) {
    const currentButton = "content-" + e.target.dataset.contentid;
    this.setState((prevState) => ({
      [currentButton]: !prevState[currentButton],
    }));
  }

  triggerModal(type = "rules") {
    this.props.modal(type);
  }

  toggleActiveTab = (tab) => {
    this.props.toggleActiveTab(tab, true);
  };
  render() {
    const { language, campEnded, activeTab } = this.props;
    return (
      <div
        className="content--wrapper"
        //style={{ backgroundImage: 'url("./assets/images/bg.jpg")' }}
      >
        <span id="miljoniloos"></span> <span id="lisaloos"></span>
        <div className="content--inside" id="campaign">
          <div className="content--tabs">
            <div
              className={`tab tab-${language} ${
                activeTab === "lisaloos" ? "is-active" : ""
              }`}
              onClick={() => this.toggleActiveTab("lisaloos")}
            >
              {language === "et" ? "Lisaloos" : "Дополнительный розыгрыш"}
            </div>
            <div
              className={`tab tab-${language} ${
                activeTab === "miljoniloos" ? "is-active" : ""
              }`}
              onClick={() => this.toggleActiveTab("miljoniloos")}
            >
              {language === "et" ? "Miljoniloos" : "Розыгрыш Миллиона"}
            </div>
          </div>
          {campEnded ? (
            <div className="content--full campEnded">
              {language === "et" ? (
                <p className="text--align__center">Kampaania on lõppenud</p>
              ) : (
                <p className="text--align__center">Кампания завершилась</p>
              )}
            </div>
          ) : (
            <div className="content--full">
              <h2 className="text--align__center">
                {activeTab === "miljoniloos" ? (
                  <>
                    {language === "et"
                      ? "1 miljon eurot kindlalt Eestisse!"
                      : "1 миллион евро в Эстонию!"}
                  </>
                ) : (
                  <>
                    {language === "et"
                      ? "Aastaloos taas Eestis!"
                      : "Розыгрыш Года вновь в Эстонии!"}
                  </>
                )}
              </h2>
            </div>
          )}
          {activeTab === "miljoniloos" ? (
            <div className="content--full content--header">
              {language === "et" ? (
                <p className="text">
                 Vastavalt Vikinglotto mängureeglitele osalevad Miljoniloosi loosimisel kõik 01.01.2023 kuni 31.12.2023 ostetud Vikinglotto piletid. Iga mängukombinatsioon piletil annab eraldi võiduvõimaluse.
                </p>
              ) : (
                <p className="text">
             В соответствии с правилами игры Vikinglotto в розыгрыше Миллиона примут участие все билеты Vikinglotto, купленные с 01.01.2023 по 31.12.2023. Каждая игровая комбинация на билете даёт отдельную выигрышную возможность.
                </p>
              )}

              <div className="box">
                <p className="box--title">
                  {language === "et"
                    ? "Kuidas miljon loositakse?"
                    : "Как разыгрывается миллион?"}
                </p>
                <p className="box--text">
                  {language === "et"
                    ? `Vastavalt Vikinglotto reeglitele võib miljon jaguneda kuni viie
              kombinatsiooni vahel ja seetõttu loositakse esimesena välja
              number vahemikus ühest viieni (1-5), mis näitab, mitme võitja
              vahel läheb jagamisele miljon eurot. Seejärel loositakse välja
              mängukombinatsioonid, millega seotud pileti omanik on võitnud
              vastava osa miljonist eurost.`
                    : `Согласно правилам Vikinglotto миллион евро может быть поровну разделён между 5 игровыми комбинациями и поэтому в первую очередь будет разыгран один номер в промежутке от одного до пяти (1-5), который укажет сколько победителей разделят между собой миллион евро. После этого будут разыграны выигрышные игровые комбинации и обладатели билетов, содержащих эти комбинации, выиграют соответствующую долю миллиона евро.`}
                </p>
              </div>

              {language === "et" ? (
                <p className="text">
                  Miljoniloosi saade on eetris 7. jaanuaril 2024 TV3-s. Saate
                  salvestuse publiku registreerimine toimub kuni 17. detsembrini
                  telefonil 650 2030 või e-posti teel{" "} <a className="clickableText" href="mailto:klienditugi@eestiloto.ee">klienditugi@eestiloto.ee</a>.
                </p>
              ) : (
                <p className="text">
                  Телепередача с розыгрышем года выйдет в эфир 7 января 2024
                  года на TV3. Регистрация публики на запись передачи проводится
                  до 17 декабря по телефону 650 2030 или по электронной почте{" "}
                  <a className="clickableText" href="mailto:klienditugi@eestiloto.ee">klienditugi@eestiloto.ee</a>.
                </p>
              )}

              <div className="box">
                <p className="box--title">
                  {language === "et"
                    ? `Publiku registreerimine`
                    : `Регистрация публики`}
                </p>
                <p className="box--text">
                  {language === "et" ? (
                    <>
                      {`Loosimise salvestusele pääseb 40 registreerunud osalejat (koos kaaslasega), kes loositakse välja Eesti Lotos 18.12.2023. Stuudiopubliku loosimisel osalemiseks tuleb osta ajavahemikul 01.11.–17.12.2023 Vikinglotto pilet ja registreeruda kuni 17. detsembrini Eesti Loto telefonil 650 2030.
            `}
                      <br />
                      <br />
                      {`Registreerumisel tuleb teatada oma nimi, isikukood, kehtiva pileti number ja telefoninumber.
Iga pileti kohta saab loosimisel osaleda üks kandidaat, olenemata pileti kombinatsioonide ja loosimiste arvust.
Iga kandidaat saab loosimisel osaleda ühe häälega, sõltumata registreeringute arvust erinevate piletitega. Ühe kõne jooksul saab helistaja soovi korral registreerida mitu kandidaati.
Saate salvestuse kandidaadiks registreeruja peab olema vähemalt 16 aastat vana.
Iga saatesse loositud mängija, kes osaleb saate salvestusel, on võitnud 100 eurot.`}
                    </>
                  ) : (
                    <>
                      {`Участие в съемке телепередачи (40 пригласительных на двоих) разыгрывается в Eesti Loto 18.12.2023. Для участия в розыгрыше пригласительных нужно купить с 01.11.2023 по 17.12.2023 билет Vikinglotto и зарегистрировать его до 17 декабря, позвонив в Eesti Loto по номеру 650 2030. `}
                      <br />
                      <br />
                      {`
                    При регистрации нужно сообщить свое имя, личный код, номер билета и номер телефона. В розыгрыше пригласительных могут участвовать по одному кандидату на билет вне зависимости от числа отмеченных на билете комбинаций и розыгрышей.
                    Кандидаты во время розыгрыша имеют по одному голосу вне зависимости от числа регистраций по разным билетам. В ходе одного телефонного звонка при желании можно зарегистрировать несколько кандидатов.
                    Регистрироваться для участия в розыгрыше пригласительных могут лица не моложе 16 лет.
                    Каждому игроку, получившему приглашение в студию и принявшему участие в записи передачи, выплачивается выигрыш в 100 евро.`}
                    </>
                  )}
                </p>
              </div>
            </div>
          ) : (
            // lisaloos
            <div className="content--full content--header">
              {language === "et" ? (
                <>
                  <p className="text">
                    Vikinglotto lisaloosis osalevad kõik{" "}
                    <span className="text--bold">
                      01.11.2023 kuni 31.12.2023
                    </span>{" "}
                    ostetud Vikinglotto piletid. Iga mängukombinatsioon piletil
                    annab eraldi võiduvõimaluse.
                  </p>
                  <p className="text">
                    Aastaloosi saade on eetris{" "}
                    <span className="text--bold">7. jaanuaril 2024 TV3-s</span>.
                    Saate salvestuse publiku registreerimine kuni 17.
                    detsembrini 2023 telefonil 650 2030. <br />{" "}
                    <span
                    className="clickableText"
                      style={{ textDecoration: "underline" }}
                      onClick={() => this.toggleActiveTab("miljoniloos")}
                    >
                      Loe lisaks{" "}
                    </span>
                  </p>
                </>
              ) : (
                <>
                  <p className="text">
                    В Розыгрыше года участвуют все билеты Vikinglotto, купленные
                    <span className="text--bold">
                      с 01.11.2023 до 31.12.2023.
                    </span>{" "}
                    Каждая игровая комбинация билета даёт отдельную возможность
                    выигрыша.
                  </p>
                  <p className="text">
                    Передача Розыгрыша года выйдет в эфир TV3{" "}
                    <span className="text--bold">7 января 2024.</span>
                    Регистрация публики на запись передачи продлится до 17
                    декабря 2023 по телефону 650 2030.
                  </p>
                </>
              )}

                <div className="prizes">
                <img
                  src="./assets/images/car.png"
                  alt="Volkswagen ID.4 NEW PRO SO 77KWH"
                />
                <div className="prizes--stats">
                  <div onClick={() => this.triggerModal("prize")}>
                    <span >
                      2 <span>x</span> Volkswagen ID.4
                    </span>
                  </div>
                </div>
                {language === "et" ? (
                  <p className="prizes">
                    Lisaks 5&nbsp;x&nbsp;10&nbsp;000 eurot
                    ja&nbsp;5&nbsp;x&nbsp;5000 eurot
                  </p>
                ) : (
                  <p className="prizes">
                    Также 5&nbsp;x&nbsp;10&nbsp;000 евро
                    и&nbsp;5&nbsp;x&nbsp;5&nbsp;000 евро
                  </p>
                )}
                </div> 
            </div>
          )}

          <Winners language={language} />
        </div>
      </div>
    );
  }
}
